var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.running)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm._f("formatTime")(_vm.hours))+":"+_vm._s(_vm._f("formatTime")(_vm.minutes))+":"+_vm._s(_vm._f("formatTime")(_vm.seconds)))]):_c('p',{staticClass:"mb-0"},[_vm._v("Comenzar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }